import React, { useEffect, useState, useRef } from "react";
import aboutb1ldots1 from './../../../images/aboutb1ldots1.png'
import aboutb1ldots2 from './../../../images/aboutb1ldots2.png'
import aboutb1ldots3 from './../../../images/aboutb1ldots3.png'
import ProducerImg2 from './../../../images/producerpgimg2.png'
import aboutb1rdots1 from './../../../images/aboutb1rdots1.png'
import aboutb1rdots2 from './../../../images/aboutb1rdots2.png'
import aboutb1lmatrix from './../../../images/aboutb1lmatrix.png'
import aboutb1rmatrix from './../../../images/aboutb1rmatrix.png'
import ProdcerDots5 from './../../../images/producerdots5.png'
import ProdcerDots7 from './../../../images/producerdots7.png'
import ProdcerDots8 from './../../../images/producerdots8.png'
import ProdcerDots9 from './../../../images/producerdots9.png'
import aboutb2ldots from './../../../images/aboutb2ldots.png'
import aboutb2lmatrix from './../../../images/aboutb2lmatrix.png'
import aboutb2rdots1 from './../../../images/aboutb2rdots1.png'
import aboutb2rdots2 from './../../../images/aboutb2rdots2.png'
import aboutb2rmatrix from './../../../images/aboutb2rmatrix.png'
import aboutb3ldots from './../../../images/aboutb3ldots.png'
import aboutb3nervesign from './../../../images/aboutb3nervesign.png'
import aboutb3rdots from './../../../images/aboutb3rdots.png'
import aboutb4divb from './../../../images/aboutb4divb.png'
import aboutb4divl from './../../../images/aboutb4divl.png'
import aboutstatsimg from './../../../images/aboutstatsimg.png'
import aboutb4divr from './../../../images/aboutb4divr.png'
import aboutb4divt from './../../../images/aboutb4divt.png'
import aboutb4llines from './../../../images/aboutb4llines.png'
import aboutformsmallE from './../../../images/aboutformsmallE.png'
import artistdots1 from './../../../images/artistdots1.png'
import aboutformbigE from './../../../images/aboutformbigE.png'
import aboutb4rlines from './../../../images/aboutb4rlines.png'
import aboutb5llines from './../../../images/aboutb5llines.png'
import aboutb5rlines from './../../../images/aboutb5rlines.png'
import fugalogo from './../../../images/fugalogo.png'
import lyricvidslogo from './../../../images/lyricvidslogo.png'
import worldcollectionlogo from './../../../images/worldcollectionlogo.png'
import aboutb6llines from './../../../images/aboutb6llines.png'
import aboutb6rlines from './../../../images/aboutb6rlines.png'
import { hover } from "@testing-library/user-event/dist/hover";
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { Trans, useTranslation } from 'react-i18next'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import Footer from "../../Footer/Footer";
import N3rveLogo from './../../../images/N3rveLogo.png'
import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import ProdcerDots2 from './../../../images/producerdots2.png'
import ProdcerDots4 from './../../../images/producerdots4.png'
import NerveBlackRose from './../../../images/blackrose.png'
import ProdcerDots6 from './../../../images/producerdots6.png'
import NerveVerticalTxt from './../../../images/nerveverticaltxt.png'
import ProducerWidget1 from './../../../images/producerimg1.jpg'
import producerdetailssquare from './../../../images/producerdetailssquare.png'
import ProducerWidget2 from './../../../images/producerimg2.png'
import ProducerWidget3 from './../../../images/producerimg3.jpg'
import ProducerWidget4 from './../../../images/producerimg4.png'
import ProducerWidget5 from './../../../images/producerimg5.jpg'
import ProducerWidget6 from './../../../images/producerimg6.png'
import TriangleBullet from './../../../images/TriangleBullet.png'
// import N3XDBANNER from './../../../images/N3XDBANNER.mp4'
import nexdb2img from './../../../images/nexdb2img.png'
import nexdartist1 from './../../../images/nexdartist1.png'
import nexdartist2 from './../../../images/nexdartist2.png'
import nexdartist3 from './../../../images/nexdartist3.png'
import nexdlogo from './../../../images/nexdlogo.webp'
import './LabelAndEnterprise.css'
import NerveMusicHome from "./NerveMusicHome";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";

function LabelAndEnterprise() {
  const [formView, setFormView] = useState(false)
  const [scrollPosition, setScrollPosition] = useState();
  const navigate = useNavigate()
  const cookies = new Cookies(null, { path: '/' });
  const { t, i18n } = useTranslation();
  const [maxScroll, setMaxScroll] = useState(0);
  const parentRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [projectNotes, setProjectNotes] = useState("")
  const [spotifyLink, setSpotifyLink] = useState("")
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  const hasLogged = useRef(false);

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }


  useEffect(() => {
    topFunction()

    const parentHeight = parentRef.current ? parentRef.current.offsetHeight : 0;
    const windowHeight = window.innerHeight;

    // Set the maximum scrollable distance based on the parent div's height
    setMaxScroll(parentHeight - windowHeight);
    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "NEXD Page", { "desc": "User opened the NEXD page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "NEXD Page", { "desc": "User opened the NEXD page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "NEXD Page", { "desc": "User opened the NEXD page" })
        hasLogged.current = true;
      }
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener("resize", handleResize, false);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };


  }, [])

  useEffect(() => {
  }, [projectNotes])

  const LogForm = (name, email, notes, profilelink) => {
    if (cookies.get('token') !== undefined) {
      if (decodeToken(cookies.get('token')) !== null) {
        logtoWix(decodeToken(cookies.get('token')).email, "form submit", "NEXD Page", { "desc": "User filled submit application form", "name": name, "email": email, "notes": notes, "profilelink": profilelink })

      } else {
        logtoWix("anonymous user", "form submit", "NEXD Page", { "desc": "User filled submit application form", "name": name, "email": email, "notes": notes, "profilelink": profilelink })

      }
    } else {
      logtoWix("anonymous user", "form submit", "NEXD Page", { "desc": "User filled submit application form", "name": name, "email": email, "notes": notes, "profilelink": profilelink })

    }
  }

  useEffect(() => {

  }, [projectNotes])

  const translateY = scrollPosition > 100 ? Math.min(scrollPosition - 100, maxScroll) : 0;

  return (
    <div>
      {/* ******************************************** */}


      {/* DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Parallax >
            <ParallaxLayer offset={0} speed={0.4} factor={2} style={{
              width: '150vw',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              paddingLeft: '17em',
              height: "150vh",
              // backgroundImage:`url(${aboutbanner})`, 
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPositionX: '-50vw',
              zIndex: '-1'
            }}>
              <video
                // src={require('./../../../images/N3XDBANNER.mp4')} // Path to your video file
                src={"https://res.cloudinary.com/ddvootytq/video/upload/f_auto:video,q_auto/nevpk0ojgur7ovh6vofk"} // Path to your video file
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-70%, -50%)',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensures the video covers the entire layer
                  zIndex: '-1', // Keeps video behind other content
                }}
              />

            </ParallaxLayer>
            <div className="ArtistsContainer">
              <div style={{
                // backgroundImage:`url(${ArtistPgImg1})`, 
                height: '100vh',
                // height:'50px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundSize: 'cover',
                position: 'relative'
              }}>

                <img src={nexdlogo} style={{ width: '29.375em', height: '8em', zIndex: '4', position: 'absolute', bottom: '2em', left: '8%' }} />

                <div className='ThisIsWhereTxt' style={{ fontWeight: '500', letterSpacing: '1px', alignSelf: 'flex-start', position: 'absolute', bottom: '15em', left: '8%', marginLeft: '0em' }}>
                  .. / -.-. .- -. / .-.. .. ...- . / -. . .. - .... . .-. / .-- .. - .... / -.-- --- ..- --..-- / -. --- .-. / .-<br />- .. - .... --- ..- - / -.-- --- ..-
                </div>


                <div className='Own100Rights' style={{ textAlign: 'right', position: 'absolute', bottom: '2em', right: '5%', zIndex: '4', fontWeight: '600', letterSpacing: '1px' }}>
                  The Ultimate Solution for Top<br /> Tier Artists, Labels & Music<br /> Rights Holders
                </div>

                <div style={{ textAlign: 'right', position: 'absolute', top: '5em', right: '5%', zIndex: '4', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em', width: 'wrap' }}>
                    BY
                  </div>

                  <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                    INVITATION
                  </div>

                  <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                    ONLY
                  </div>
                </div>


                <div className="FutureEntertainmentTxt" style={{ position: 'absolute', top: '5em', left: '5%', zIndex: '4', letterSpacing: '1px' }}>
                  FUTURE ENTERTAINMENT
                </div>

              </div>

            </div>



            {/* <div style={{display:'flex',flexDirection:'column',backgroundColor:'#0F0F12',paddingBottom:'9.34em',paddingTop:'3.87em'}}>
                    <div  style={{display:'flex',flexDirection:'row',justifyContent:'center',width:'95%',alignSelf:'center'}}>
                      <div style={{display:'flex',flexDirection:'column'}}> 
                        <div className="BuilttoBreak" style={{maxWidth:'13.71em'}}>
                        Built To Break & Support Artists Around The Globe
                        </div>

                        <div className="FUGAteam" style={{maxWidth:'26.1em'}}>
                        The FUGA team manages YouTube channels in partnership with our clients, working together to increase viewership, content discovery, and video earnings through FUGA’s exclusive Music Multi-Channel Network.
                        </div>
                      </div>
                      <img src={nexdb2img} style={{aspectRatio:'1.74',width:'51.97%',maxWidth:'748.4px'}}/>
                    </div>

                    <div  style={{display:'flex',flexDirection:'row',width:'95%',marginTop:'9.06em',alignSelf:'center'}}>
                      <img src={nexdartist1} style={{width:'17.03em',height:'18.15em',marginRight:'1.75em'}}/>
                      <img src={nexdartist2} style={{width:'17.03em',height:'18.15em',marginRight:'1.75em'}}/>
                      <img src={nexdartist3} style={{width:'17.03em',height:'18.15em',marginRight:'1.75em'}}/>
                    </div>
                    
            </div> */}

            {/* <div style={{ 
                            // backgroundImage:`url(${ProducerImg2})`, 
                            backgroundColor:'#15171B',
                            height:'125.5em',
                            // height:'50px',
                            width:'100%',
                            backgroundSize:'cover',
                            display:'flex',
                            flexDirection:'column',
                            alignItems:'center',
                            position:'relative'
                          }}>
                       <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'1.5%',top:'7.815em'}}/>
                       <img src={NerveBlackRose} style={{position:'absolute',width:'30.93em',height:'30.56em',left:'1.5%',top:'4.815em'}}/>
                       <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'2.5%',top:'65.73em'}}/>
                       <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'2.5%',top:'105.73em'}}/>

                       <img src={NerveVerticalTxt} style={{position:'absolute',width:'18.06em',height:'100.67em',right:'2.89em',top:'2em'}}/>
                      <div className='FromPlatform' style={{marginTop:'1.5em'}}>FROM PLATFORM TO PARTNER</div>
                      <div className='BespokeArtist'>Bespoke Artist Services & Career Planning That Includes:</div>


                      <div style={{display:'flex',flexDirection:'row',marginTop:'3.21em',justifyContent:'center',width:'70%',position:'relative'}}>
                      
                         

                        <div style={{display:'flex',flexDirection:'column'}}>

                          <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp; Global Distribution & Marketing</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                Distribution to over 150+ DSPs around the globe, with comprehensive marketing campaigns that cover content, playlisting, pr, radio, and more. 
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'-1.5em'}}>
                            <div className="div"style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
                            <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
                          </div>
                        </div>

                      </div>


                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                      <div style={{display:'flex',flexDirection:'column'}}>

                      <div style={{display:'flex',flexDirection:'column',marginLeft:'-1em'}}>
                        <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;  Advanced Funding</span>
                        <div style={{display:'flex',flexDirection:'row'}}>
                        
                          <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                          <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>We provide the financial resources needed for artists and labels to unlock doors & grow careers.</div>
                            </div>
                        </div>
                      </div>
                      <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginTop:'1em'}}>
                        <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
                        <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>
                        
                      </div>
                      </div>

                      
                      </div>

                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                        

                          <div style={{display:'flex',flexDirection:'column'}}>

                          <div style={{display:'flex',flexDirection:'column'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;&nbsp;In House Publishing</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                Protect and collect what is yours through the industries most advanced publishing service and synch promotions.
                              
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginTop:'1em'}}>
                            <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
                            <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
                          </div>
                          </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                        

                          <div style={{display:'flex',flexDirection:'column'}}>

                          <div style={{display:'flex',flexDirection:'column'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;&nbsp;Release Management</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                With distribution & publishing at your finger tips, we help you create and manage precise campaigns for each track and release to help top the charts.
                              
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginTop:'1em'}}>
                        <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
                        <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>
                        
                      </div>
                          </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                        

                          <div style={{display:'flex',flexDirection:'column'}}>

                          <div style={{display:'flex',flexDirection:'column'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;&nbsp;Content Monetization</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                The most powerful UGC and Rights Management service in the industry to make sure you monetize and collect what’s owed on all of your content.
                              
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginTop:'1em'}}>
                            <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
                            <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
                          </div>
                          </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                        

                          <div style={{display:'flex',flexDirection:'column'}}>

                          <div style={{display:'flex',flexDirection:'column'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;&nbsp;Business Management</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                Top Tier Talent requires a robust business team behind them to help navigate the ins & outs of the business side of music so you can focus on your craft. We’re the best in the bizz for A-listers.
                              
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginTop:'1em'}}>
                        <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
                        <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>
                        
                      </div>
                          </div>
                      </div>

                      <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'70%'}}>

                        

                          <div style={{display:'flex',flexDirection:'column',marginLeft:'5.4em'}}>

                          <div style={{display:'flex',flexDirection:'column'}}>
                            <span className='ProducerWidgetHeaderR' style={{textAlign:'left'}}><span style={{color:'#E91353'}}>//</span>&nbsp;&nbsp;A Full Time Team Of Dedicated Industry Professionals</span>
                            <div style={{display:'flex',flexDirection:'row'}}>
                            
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                              <img  src={producerdetailssquare} style={{width:'2.5em',height:'2.5em',marginRight:'3em',marginTop:'1em',marginLeft:'0em',zIndex:'2'}}/>
                                <div className='ProducerWidgetDescR' style={{textAlign:'left'}}>
                                With over 170 team members around the world, we have the every corner of the globe covered to optimize your reach.
                              
                                </div>
                                </div>
                            </div>
                          </div>
                          <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginTop:'1em'}}>
                            <div className="div" style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
                            <div className="div" style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
                          </div>
                          </div>
                      </div>


              </div> */}

            <NerveMusicHome />

            <div style={{
              backgroundColor: '#000000',
              //  height:'38em',
              width: '100%',
              backgroundSize: 'cover',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              overflow: 'hidden',
              zIndex: '1'
            }}
            >
              <img src={artistdots1} style={{ width: '1.48em', height: '30.33em', position: 'absolute', left: '2em', top: '8em', zIndex: '1' }} />

              <div style={{ display: 'flex', flexDirection: 'row', width: '80%', paddingTop: '5em', paddingBottom: '6.81em', justifyContent: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', zIndex: '5' }}>
                  <div className="colorfulSlashes">//</div>
                  <div className="AboutH2" style={{ maxWidth: '10.54em', marginBottom: '0.5em' }}>Submit Your Application</div>
                  <div className="AboutH5" style={{ maxWidth: '24em' }}>Fill out the form with your project details to help us understand your vision. </div>
                </div>

                <div className="AboutFormContainer">
                  <div className="AboutFormTitle">
                    Name
                  </div>

                  <input
                    value={name}
                    onChange={e => setName(e.target.value)}
                    className='AboutFormInput'
                  />

                  <div className="AboutFormTitle">
                    Email
                  </div>

                  <input
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className='AboutFormInput'
                  />

                  <div className="AboutFormTitle">
                    Project Notes
                  </div>

                  <textarea rows="4" cols="50" className='AboutFormTextArea' onChange={e => { setProjectNotes(e.target.value); }} value={projectNotes} />

                  <div className="AboutFormTitle">
                    Spotify Profile Link
                  </div>

                  <input
                    value={spotifyLink}
                    onChange={e => setSpotifyLink(e.target.value)}
                    className='AboutFormInput'
                  />

                  <div className="AboutUpdateBtn" onClick={() => { LogForm(name, email, projectNotes, spotifyLink); setName(""); setEmail(""); setProjectNotes(""); setSpotifyLink("") }}>
                    Submit
                    <div className="PostLoginBtnOverlay" style={{ left: '0em' }} />
                  </div>

                </div>
                {/* <img src={aboutformbigE} style={{width:'38.75em',height:'38.47em',position:'absolute',right:'48%',top:'5em',zIndex:'1'}}/> */}
              </div>

              {/* <img src={aboutformsmallE} style={{width:'34.14em',height:'30.33em',position:'absolute',right:'-0.8em',top:'-0.5em',zIndex:'1'}}/> */}

            </div>





            <Footer />
          </Parallax>
        </div>
      }



      {/* ******************************************** */}


      {/* TABLET AND MOBILE VIEW */}

      {
        dimensions.width < 1024 &&
        <div style={{ display: 'flex', flexDirection: 'column' }}>

          {
            dimensions.width < 1024 && dimensions.width >= 768 &&
            <div style={{
              // backgroundImage:`url(${aboutbanner})`, 
              height: '30.515em',
              // height:'50px',
              width: '100%',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              position: 'relative'
            }}>
              <video
                // src={require('./../../../images/N3XDBANNER.mp4')} // Path to your video file
                src={"https://res.cloudinary.com/ddvootytq/video/upload/f_auto:video,q_auto/nevpk0ojgur7ovh6vofk"} // Path to your video file
                autoPlay
                loop
                muted
                style={{
                  position: 'absolute',
                  top: '0%',
                  left: '0%',
                  // transform: 'translate(-70%, -50%)',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensures the video covers the entire layer
                  zIndex: '-1', // Keeps video behind other content
                }}
              />
              <img src={nexdlogo} style={{ aspectRatio: '3.67', width: '40%', zIndex: '4', position: 'absolute', bottom: '2em', left: '8%' }} />

              <div className='ThisIsWhereTxt' style={{ fontWeight: '500', letterSpacing: '1px', alignSelf: 'flex-start', position: 'absolute', bottom: '10em', left: '8%', marginLeft: '0em' }}>
                .. / -.-. .- -. / .-.. .. ...- . / -. . .. - .... . .-. / .-- .. - .... / -.-- --- ..- --..-- / -. --- .-. / .-<br />- .. - .... --- ..- - / -.-- --- ..-
              </div>


              <div className='Own100Rights' style={{ textAlign: 'right', position: 'absolute', bottom: '2em', right: '5%', zIndex: '4', fontWeight: '600', letterSpacing: '1px', width: '40%' }}>
                The Ultimate Solution for Top Tier Artists, Labels & Music Rights Holders
              </div>

              <div style={{ textAlign: 'right', position: 'absolute', top: '5em', right: '5%', zIndex: '4', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em', width: 'wrap' }}>
                  BY
                </div>

                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                  INVITATION
                </div>

                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                  ONLY
                </div>
              </div>


              <div className="FutureEntertainmentTxt" style={{ position: 'absolute', top: '5em', left: '5%', zIndex: '4', letterSpacing: '1px' }}>
                FUTURE ENTERTAINMENT
              </div>

            </div>
          }

          {
            dimensions.width < 768 &&
            <div style={{
              // backgroundImage:`url(${aboutbanner})`, 
              height: '45.515em',
              // height:'50px',
              width: '100%',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              position: 'relative'
            }}>
              <video
                // src={require('./../../../images/N3XDBANNER.mp4')} // Path to your video file
                src={"https://res.cloudinary.com/ddvootytq/video/upload/f_auto:video,q_auto/nevpk0ojgur7ovh6vofk"} // Path to your video file
                autoPlay
                loop
                muted
                style={{
                  position: 'absolute',
                  top: '0%',
                  left: '0%',
                  // transform: 'translate(-70%, -50%)',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover', // Ensures the video covers the entire layer
                  zIndex: '-1', // Keeps video behind other content
                }}
              />
              <img src={nexdlogo} style={{ aspectRatio: '3.67', width: '40%', zIndex: '4', position: 'absolute', bottom: '2em', left: '8%' }} />

              <div className='ThisIsWhereTxt' style={{ fontWeight: '500', letterSpacing: '1px', alignSelf: 'flex-start', position: 'absolute', bottom: '10em', left: '8%', marginLeft: '0em' }}>
                .. / -.-. .- -. / .-.. .. ...- <br />. / -. . .. - .... . .-<br />. / .-- .. - .... / -.-- --- <br />..- --..-- / -. --- .-. / .-<br />- .. - .... --- ..- - / -.-- --- ..-
              </div>


              <div className='Own100Rights' style={{ textAlign: 'right', position: 'absolute', bottom: '2em', right: '5%', zIndex: '4', fontWeight: '600', letterSpacing: '1px', width: '40%' }}>
                The Ultimate Solution for Top Tier Artists, Labels & Music Rights Holders
              </div>

              <div style={{ textAlign: 'right', position: 'absolute', top: '5em', right: '5%', zIndex: '4', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em', width: 'wrap' }}>
                  BY
                </div>

                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                  INVITATION
                </div>

                <div className='Own100Rights' style={{ fontWeight: '600', letterSpacing: '1px', backgroundColor: '#fff800', color: '#000000', paddingLeft: '0.5em', marginBottom: '0.8em' }}>
                  ONLY
                </div>
              </div>


              <div className="FutureEntertainmentTxt" style={{ position: 'absolute', top: '5em', left: '5%', zIndex: '4', letterSpacing: '1px' }}>
                FUTURE ENTERTAINMENT
              </div>

            </div>
          }

          {/* {
                dimensions.width >= 768 && dimensions.width <1024 && 
                
                <div style={{ backgroundImage:`url(${ProducerImg2})`, 
                height:'214em',
                // height:'50px',
                width:'100%',
                backgroundSize:'cover',
                display:'flex',
                flexDirection:'column',
                alignItems:'center'
            }}>

                    <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'3.66em',top:'42.815em'}}/>
                    <img src={ProdcerDots5} style={{position:'absolute',width:'6.61em',height:'7.008em',left:'1.16em',top:'79.312em'}}/>
                    <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'95.04em'}}/>
                    <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'127.73em'}}/>
                    <img src={ProdcerDots7} style={{position:'absolute',width:'0.375em',height:'0.414em',right:'10.048em',top:'45.75em'}}/>
                    <img src={ProdcerDots8} style={{position:'absolute',width:'0.79em',height:'0.25em',left:'2.89em',top:'125.9em'}}/>
                    <img src={ProdcerDots9} style={{position:'absolute',width:'5.91em',height:'3.04em',right:'6.18em',top:'150.85em'}}/>

                    <div className={cookies.get('lang') === 'en' ?  'ProducerPgDiv2H1': 'jp-ProducerPgDiv2H1'} style={{marginLeft:'0em',marginTop:'1.18em',textAlign:'center',fontSize:'2.5rem',fontWeight:'500',width:'80%'}}>170+ Team Members</div>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget1} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            Global Distribution &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            Distribute to every major DSP and digital store around the globe. You keep 85% of your revenue along with the freedom to leave whenever you want.
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>





                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget2} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            <span style={{color:'#E91353'}}>//</span> &nbsp; Artist Funding</span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            We put up money and you approve the marketing budget, keep creative control, and always own 100% of your masters. 
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>




                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget3} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            Precision Marketing &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            We put the muscle of our worldwide marketing team behind you, from digital campaigns to brand collaborations and visual production to push your project up the charts.
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>




                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget4} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            <span style={{color:'#E91353'}}>//</span> &nbsp; Creative, Synch, Playlisting, Radio</span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            We lean in to refine and maximize your vision and then spread it to all the places and partners that matter most, from Apple ads to Top 40 radio.
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>



                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget5} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            Publishing &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            Our targeted marketing to specific channels. demographics, regions, etc
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>



                    <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                        <img src={ProducerWidget6} style={{width:'70%',height:'17.62em'}}/>

                        
                            <span className='ProducerWidgetHeaderR' style={{fontSize:'1.5rem',fontWeight:'500',lineHeight:'140%',width:'70%'}}>
                            <span style={{color:'#E91353'}}>//</span> &nbsp; Management Insights</span>
                        
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'70%',alignSelf:'center'}}>
                            <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                            <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                            We help you flip streams into insights with skip rates, completions, playlist history, and more. We’re proud to have built the most comprehensive streaming analytics platform in music.
                            </div>
                            </div>
                        
                        


                        <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'8em'}}>
                            <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                            <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                        </div>


                    </div>
                    

                    </div>
            }

            {
                dimensions.width < 768 &&
                <div style={{ backgroundImage:`url(${ProducerImg2})`, 
                      height:'205.5em',
                      // height:'50px',
                      width:'100%',
                      backgroundSize:'cover',
                      display:'flex',
                      flexDirection:'column',
                      alignItems:'center'
                    }}>

                <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'0em',top:'37.815em'}}/>
                {/* <img src={ProdcerDots5} style={{position:'absolute',width:'6.61em',height:'7.008em',left:'1.16em',top:'79.312em'}}/> */}
          {/* <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'0em',top:'87.04em'}}/>
                <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'0.25em',top:'119.73em'}}/> */}
          {/* <img src={ProdcerDots7} style={{position:'absolute',width:'0.375em',height:'0.414em',right:'10.048em',top:'45.75em'}}/> */}
          {/* <img src={ProdcerDots8} style={{position:'absolute',width:'0.79em',height:'0.25em',left:'2.89em',top:'125.9em'}}/> */}
          {/* <img src={ProdcerDots9} style={{position:'absolute',width:'5.91em',height:'3.04em',right:'6.18em',top:'150.85em'}}/> */}

          {/* <div className={cookies.get('lang') === 'en' ?  'ProducerPgDiv2H1': 'jp-ProducerPgDiv2H1'} style={{marginLeft:'0em',marginTop:'1.18em',textAlign:'center',fontSize:'1.75em',fontWeight:'500',width:'80%'}}>170+ Team Members</div>

                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget1} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      Global Distribution &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        Distribute to every major DSP and digital store around the globe. You keep 85% of your revenue along with the freedom to leave whenever you want.
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>





                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget2} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      <span style={{color:'#E91353'}}>//</span> &nbsp; Artist Funding</span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        We put up money and you approve the marketing budget, keep creative control, and always own 100% of your masters. 
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>




                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget3} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      Precision Marketing &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        We put the muscle of our worldwide marketing team behind you, from digital campaigns to brand collaborations and visual production to push your project up the charts.
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>


                

                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget4} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      <span style={{color:'#E91353'}}>//</span> &nbsp; Creative, Synch, Playlisting, Radio</span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        We lean in to refine and maximize your vision and then spread it to all the places and partners that matter most, from Apple ads to Top 40 radio.
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>



                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget5} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      Publishing &nbsp; <span style={{color:'#E91353'}}>//</span></span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        Our targeted marketing to specific channels. demographics, regions, etc
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>



                <div style={{display:'flex',flexDirection:'column',marginTop:'3.21em',alignItems:'center',width:'100%'}}>
                    <img src={ProducerWidget6} style={{width:'80%',height:'15.62em'}}/>

                    
                      <span className='ProducerWidgetHeaderR' style={{fontSize:'1.125rem',fontWeight:'600',lineHeight:'120%',width:'90%'}}>
                      <span style={{color:'#E91353'}}>//</span> &nbsp; Management Insights</span>
                  
                      <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'80%',alignSelf:'center'}}>
                        <img  src={producerdetailssquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginRight:'-1em',zIndex:'2'}}/>
                        <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)'}}>
                        We help you flip streams into insights with skip rates, completions, playlist history, and more. We’re proud to have built the most comprehensive streaming analytics platform in music.
                        </div>
                      </div>
                    
                     

                
                    <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',marginLeft:'2.4em'}}>
                      <div style={{width:'1.05em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)'}}/>
                      <div style={{width:'8.31em',height:'0.125em',backgroundImage:'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)',marginLeft:'0.7em'}}/>
                    </div>
              

                </div>


        </div>
            }  */}

          <NerveMusicHome />
          <div style={{
            backgroundColor: '#000000',
            //  height:'38em',
            width: '100%',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            overflow: 'hidden',
            zIndex: '1'
          }}
          >


            <div style={{ display: 'flex', flexDirection: 'column', width: '95%', paddingTop: '5em', paddingBottom: '6.81em', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', zIndex: '5' }}>
                <div className="colorfulSlashes">//</div>
                <div className="AboutH2" style={{ marginBottom: '0.5em' }}>Submit Your Application</div>
                <div className="AboutH5" style={{ maxWidth: '90%' }}>Fill out the form with your project details to help us understand your vision. </div>
              </div>

              <div className="AboutFormContainer" style={{ width: '80%', marginTop: '4em' }}>
                <div className="AboutFormTitle">
                  Name
                </div>

                <input
                  value={name}
                  onChange={e => setName(e.target.value)}
                  className='AboutFormInput'
                />

                <div className="AboutFormTitle">
                  Email
                </div>

                <input
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className='AboutFormInput'
                />

                <div className="AboutFormTitle">
                  Project Notes
                </div>

                <textarea rows="4" cols="50" className='AboutFormTextArea' onChange={e => { setProjectNotes(e.target.value); }} value={projectNotes} />

                <div className="AboutFormTitle">
                  Spotify Profile Link
                </div>

                <input
                  value={spotifyLink}
                  onChange={e => setSpotifyLink(e.target.value)}
                  className='AboutFormInput'
                />

                <div className="AboutUpdateBtn" onClick={() => { LogForm(name, email, projectNotes, spotifyLink); setName(""); setEmail(""); setProjectNotes(""); setSpotifyLink("") }}>
                  Submit
                  <div className="PostLoginBtnOverlay" style={{ left: '0em' }} />
                </div>

              </div>
              {/* <img src={aboutformbigE} style={{width:'38.75em',height:'38.47em',position:'absolute',right:'48%',top:'5em',zIndex:'1'}}/> */}
            </div>

            {/* <img src={aboutformsmallE} style={{width:'34.14em',height:'30.33em',position:'absolute',right:'-0.8em',top:'-0.5em',zIndex:'1'}}/> */}

          </div>





          <Footer />
        </div>
      }


    </div>
  );
}

export default LabelAndEnterprise;